<template>
  <v-container fluid pa-0>
    <!-- Header and Search -->
    <v-layout
      row
      wrap
      align-center
      justify-space-around
      style="min-height:180px"
      :class="deviceClasses.lay1"
    >
      <v-flex xs11 sm11 md5 :class="deviceClasses.icon">
        <v-icon size="35px" class="v-middle" color="white"
          >account_circle</v-icon
        >
        <span
          class="title white--text v-middle"
          :class="$vuetify.rtl ? 'mr-3' : 'ml-3'"
          >{{ $t("profile") }}</span
        >
      </v-flex>
      <v-flex
        xs11
        md5
        class="mb-5"
        :class="$vuetify.rtl ? 'text-xs-left' : 'text-xs-right'"
      >
        <v-btn flat color="white px-0" @click="$router.go(-1)">
          <span class="pb-1 mr-2">{{ $t("return") }}</span>
          <v-icon v-html="$vuetify.rtl ? 'arrow_back' : 'arrow_forward'" />
        </v-btn>
      </v-flex>
    </v-layout>
    <!-- end of header -->
    <!-- Stepper forms -->
    <v-layout row wrap justify-center style="margin-top:-53px">
      <v-flex xs12 md11>
        <v-card>
          <v-card-title class="body-2 grey lighten-3">{{
            $t("user_details")
          }}</v-card-title>
          <v-container fluid grid-list-xs>
            <v-form class="layout row wrap justify-start px-3">
              <v-flex xs11 md5 class="text-xs-center">
                <user-avatar />
                <v-text-field
                  :label="$t('name')"
                  v-model="user.name"
                  data-vv-name="name"
                  :data-vv-as="$t('name')"
                  v-validate="'required'"
                  :error-messages="errors.collect('name')"
                />
                <v-text-field
                  type="email"
                  :label="$t('email')"
                  data-vv-name="email"
                  v-model="user.email"
                  :data-vv-as="$t('email')"
                  v-validate="'required|email'"
                  :error-messages="errors.collect('email')"
                />
                <v-text-field
                  type="password"
                  v-model="oldPassword"
                  v-validate="'required'"
                  data-vv-name="password"
                  :label="$t('old_password')"
                  :data-vv-as="$t('old_password')"
                  :error-messages="errors.collect('password')"
                />
                <v-text-field
                  ref="newPass"
                  name="newPass"
                  type="password"
                  v-model="newPass"
                  data-vv-name="newPass"
                  :label="$t('new_password')"
                  v-validate="'required|min:6'"
                  :data-vv-as="$t('new_password')"
                  :error-messages="errors.collect('newPass')"
                />
                <v-text-field
                  type="password"
                  v-model="repeatPass"
                  data-vv-name="repeatPass"
                  :label="$t('accept_password')"
                  v-validate="'confirmed:newPass'"
                  :data-vv-as="$t('accept_password')"
                  :error-messages="errors.collect('repeatPass')"
                />
              </v-flex>
              <v-flex xs11 mt-3>
                <v-btn
                  @click="submit"
                  :loading="loading"
                  :disabled="loading"
                  color="btn_color secondary mx-0"
                  >{{ $t("save") }}</v-btn
                >
              </v-flex>
            </v-form>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import userAvatar from "./userAvatar.vue";
export default {
  components: { userAvatar },
  data() {
    return {
      loading: false,
      oldPassword: null,
      newPass: "default",
      repeatPass: "default",
      user: { id: 0, name: "", email: "" }
    };
  },
  computed: {
    deviceClasses() {
      if (this.$vuetify.breakpoint.mdAndUp)
        return {
          lay1: "primary",
          icon: "mb-5 align-center"
        };
      return {
        lay1: "primary",
        icon: "mb-5 align-center"
      };
    }
  },
  methods: {
    initData() {
      this.user = Object.assign(
        {},
        this.$store.getters["AuthModule/current_user"]["user"]
      );
    },

    submit() {
      this.loading = true;
      this.$validator.validateAll().then(result => {
        if (result) {
          let data = {
            ...this.user,
            newPassword: this.newPass,
            oldPassword: this.oldPassword
          };
          this.axios.put("updateProfile", data).then(response => {
            if (response.data.success) {
              let currentUser = this.$store.getters["AuthModule/current_user"];
              currentUser.user = this.user;
              localStorage.setItem("currentUser", JSON.stringify(currentUser));

              this.$validator.reset();
              this.$store.commit("showSnackbar", {
                text: this.$t("save_succeed"),
                stateType: "success",
                show: true
              });
            } else {
              this.errors.add({ field: "password", msg: response.data.msg });
            }
          });
        } else {
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input"),
            stateType: "error",
            show: true
          });
        }
      });
      this.loading = false;
    }
  },
  created() {
    this.initData();
  }
};
</script>
